var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n    v-input\n    k-filter-v-input k-filter-v-date\n    v-text-field v-text-field--box v-text-field--enclosed\n    v-input--hide-details\n    theme--light\n  "
    },
    [
      _c("div", { staticClass: "v-input__control" }, [
        _c("div", { staticClass: "v-input__slot" }, [
          _c(
            "div",
            { staticClass: "v-text-field__slot" },
            [
              _c(
                "label",
                { class: _vm.labelClass, attrs: { "aria-hidden": "true" } },
                [_vm._v(_vm._s(_vm.labelText))]
              ),
              _vm._v(" "),
              _vm.isDateTime
                ? _c("date-time-picker", {
                    ref: "input",
                    class: [_vm.inputClass, "sb-table-datetimepicker"],
                    attrs: {
                      value: _vm.value,
                      format: _vm.format,
                      disabled: _vm.disabled,
                      show: _vm.showDatetimePicker,
                      "popup-settings": {
                        popupClass: "table-filter-date-picker"
                      }
                    },
                    on: {
                      change: _vm.handleDateChange,
                      focus: function($event) {
                        $event.stopPropagation()
                        return _vm.handlePickerFocus($event)
                      },
                      blur: _vm.handlePickerBlur,
                      iconclick: _vm.handleDatetimeIconClick
                    }
                  })
                : _c("date-picker", {
                    ref: "input",
                    class: _vm.inputClass,
                    attrs: {
                      value: _vm.value,
                      format: _vm.format,
                      disabled: _vm.disabled,
                      "popup-settings": {
                        popupClass: "table-filter-date-picker"
                      }
                    },
                    on: {
                      change: _vm.handleDateChange,
                      focus: function($event) {
                        $event.stopPropagation()
                        return _vm.handlePickerFocus($event)
                      },
                      blur: _vm.handlePickerBlur
                    }
                  })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }